export const getShortId = () => {
  return Math.random().toString(36).slice(-6);
};
